import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const WomensNikeDFShirt = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[14].productName}
				color={product.allGear[14].color}
				size={product.allGear[14].sizes}
				price={product.allGear[14].price}
				img={product.allGear[14].img}
				miniImg1={product.allGear[14].miniImg1}
				miniImg2={product.allGear[14].miniImg2}
				miniImg3={product.allGear[14].miniImg3}
			/>
		</React.Fragment>
	);
};

export default WomensNikeDFShirt;
